import { render, staticRenderFns } from "./MonthlySLDRoyaltyIncentive.vue?vue&type=template&id=6f1eb590&"
import script from "./MonthlySLDRoyaltyIncentive.vue?vue&type=script&lang=js&"
export * from "./MonthlySLDRoyaltyIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports